import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ConfirmationDialog, ConfirmationDialogDefinition} from '@aviary/dialogs/confirmation-dialog/confirmation-dialog.types';
import {ConfirmationDialogComponent} from '@aviary/dialogs/confirmation-dialog/confirmation-dialog.component';
import {HoldDetailComponent} from '@app/my-account/holds/hold-detail/hold-detail.component';
import {HoldDialogData} from '@store/holds/holds.types';

@Component({
  selector: 'px-cancel-hold-dialog',
  template: `
    <mx-confirmation-dialog [definition]="dialogDefinition">
      <px-hold-detail [hold]="hold"/>
    </mx-confirmation-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ConfirmationDialogComponent, HoldDetailComponent]
})
export class CancelHoldDialog implements ConfirmationDialog<HoldDialogData> {
  public readonly dialogData: HoldDialogData = inject(MAT_DIALOG_DATA);
  public readonly hold = this.dialogData.hold;

  public readonly dialogDefinition: ConfirmationDialogDefinition = {
    title: 'Cancel Hold',
    prompt: 'Are you sure you wish to cancel this hold?',
    confirmButtonLabel: 'Yes, Cancel this hold'
  };
}
